import { t, useI18n } from "@bookingcom/lingojs-react";
import { CalendarCheckIcon, MoneyIncomingIcon } from "@bookingcom/bui-assets-react/streamline";
const iconsMap = {
    CHANGEABLE_TICKET: CalendarCheckIcon,
    CANCELLABLE_TICKET: MoneyIncomingIcon
};
const useFareRulesInfoWithPartialsController = (flight) => {
    const i18n = useI18n();
    const featuresDisplay = flight.fareRules?.featuresDisplay;
    const fareRules = featuresDisplay?.features.map((f) => ({
        featureName: f.featureName,
        icon: iconsMap[f.featureName],
        label: f.label
    }));
    const hasFareRules = !!fareRules && !!fareRules.length;
    return {
        header: i18n.trans(t("flights_fd_fare_rules_header")),
        subheader: i18n.trans(t("flights_fd_fare_rules_subhead_policy_info")),
        hasFareRules,
        fareRules,
        disclaimer: featuresDisplay?.disclaimer
    };
};
export default useFareRulesInfoWithPartialsController;
